import httpApiApplication from '@/app/http/httpApiApplication';

import { type TaxpayerSummary } from '../models/Taxpayer';

export const taxpayerService = {
  listMostRecentTaxpayers: async (): Promise<Array<TaxpayerSummary>> => {
    const response = await httpApiApplication.get<Array<TaxpayerSummary>>('/taxpayers/recent');

    return response;
  }
};
